export const cityTranslations = {
  "Phnom Penh": { uk: "Пномпень", ru: "Пномпень" },
  Melbourne: { uk: "Мельбурн", ru: "Мельбурн" },
  Zaporizhzhya: { uk: "Запоріжжя", ru: "Запорожье" },
  Dnipro: { uk: "Дніпро", ru: "Днепр" },
  Tangerang: { uk: "Тангеранг", ru: "Тангеранг" },
  Yangon: { uk: "Янгон", ru: "Янгон" },
  Neuquén: { uk: "Некен", ru: "Некен" },
  Jakarta: { uk: "Джакарта", ru: "Джакарта" },
  "North Bergen": { uk: "Норт-Берген", ru: "Норт-Берген" },
  Roanoke: { uk: "Роанок", ru: "Роанок" },
  Clifton: { uk: "Кліфтон", ru: "Клифтон" },
  "Iloilo City": { uk: "Ілоїло", ru: "Илоило" },
  "Port Elizabeth": { uk: "Порт-Елізабет", ru: "Порт-Елизабет" },
  Atkarsk: { uk: "Аткарськ", ru: "Аткарск" },
  Cairo: { uk: "Каїр", ru: "Каир" },
  "Mexico City": { uk: "Мехіко", ru: "Мехико" },
  Hanoi: { uk: "Ханой", ru: "Ханой" },
  Dalian: { uk: "Далянь", ru: "Далянь" },
  Saskatoon: { uk: "Саскатун", ru: "Саскатун" },
  Shanghai: { uk: "Шанхай", ru: "Шанхай" },
  "Várzea Grande": { uk: "Варзеа-Гранде", ru: "Варзеа-Гранде" },
  Belgrade: { uk: "Белград", ru: "Белград" },
  "Porto Velho": { uk: "Порту-Велью", ru: "Порту-Велью" },
  Olinda: { uk: "Олінда", ru: "Олинда" },
  Klaipėda: { uk: "Клайпеда", ru: "Клайпеда" },
  Cincinnati: { uk: "Сінсинаті", ru: "Синсиннати" },
  Depok: { uk: "Депок", ru: "Депок" },
  "São Paulo": { uk: "Сан-Паулу", ru: "Сан-Паулу" },
  Henrico: { uk: "Генріко", ru: "Генрико" },
  Santiago: { uk: "Сантьяго", ru: "Сантьяго" },
  "Antônio Dias": { uk: "Антоніо Діас", ru: "Антонио Диас" },
  Leeds: { uk: "Лідс", ru: "Лидс" },
  Uibaí: { uk: "Убаї", ru: "Убаи" },
  Tvrdošín: { uk: "Твердошін", ru: "Твердошин" },
  "Mountain View": { uk: "Маунтін-В'ю", ru: "Маунтин-Вью" },
  "Lauro de Freitas": { uk: "Лауро-де-Фрейтас", ru: "Лауро-де-Фрейтас" },
  Moscow: { uk: "Москва", ru: "Москва" },
  Concord: { uk: "Конкорд", ru: "Конкорд" },
  Tripoli: { uk: "Тріполі", ru: "Триполи" },
  Oslo: { uk: "Осло", ru: "Осло" },
  Ogbomoso: { uk: "Огбомосо", ru: "Огбомосо" },
  Wenzhou: { uk: "Веньчжоу", ru: "Вэньчжоу" },
  Sidoarjo: { uk: "Сідоарджо", ru: "Сидоарджо" },
  "Serra Talhada": { uk: "Серра-Тальяда", ru: "Серра-Тальяда" },
  Nuremberg: { uk: "Нюрнберг", ru: "Нюрнберг" },
  Lahore: { uk: "Лахор", ru: "Лахор" },
  Bucaramanga: { uk: "Букараманда", ru: "Букараманга" },
  Durban: { uk: "Дурбан", ru: "Дурбан" },
  Sofia: { uk: "Софія", ru: "София" },
  Nilópolis: { uk: "Нілополіс", ru: "Нилополис" },
  Mijas: { uk: "Міхас", ru: "Михас" },
  Novomoskovsk: { uk: "Новомосковськ", ru: "Новомосковск" },
  "Rostov-on-Don": { uk: "Ростов-на-Дону", ru: "Ростов-на-Дону" },
  Guasave: { uk: "Гуасаве", ru: "Гуасаве" },
  Warsaw: { uk: "Варшава", ru: "Варшава" },
  Semarang: { uk: "Семаранг", ru: "Семаранг" },
  Covington: { uk: "Ковінгтон", ru: "Ковингтон" },
  "South Tangerang": { uk: "Південний Тангеранг", ru: "Южный Тангеранг" },
  Itaboraí: { uk: "Ітабоараі", ru: "Итабоараи" },
  Rawalpindi: { uk: "Равалпінді", ru: "Равалпинди" },
  Fortaleza: { uk: "Форталеза", ru: "Форталеза" },
  Irecê: { uk: "Іресе", ru: "Иресе" },
  "St Petersburg": { uk: "Санкт-Петербург", ru: "Санкт-Петербург" },
  Caseros: { uk: "Касерос", ru: "Касерос" },
  Tokyo: { uk: "Токіо", ru: "Токио" },
  Voronezh: { uk: "Воронеж", ru: "Воронеж" },
  Taganrog: { uk: "Таганрог", ru: "Таганрог" },
  "Belo Horizonte": { uk: "Белу-Горизонті", ru: "Белу-Горизонти" },
  Hayden: { uk: "Хейден", ru: "Хейден" },
  Dexter: { uk: "Декстер", ru: "Декстер" },
  Umag: { uk: "Умаг", ru: "Умаг" },
  Brasília: { uk: "Бразиліа", ru: "Бразилия" },
  "Rio das Ostras": { uk: "Ріо-дас-Острас", ru: "Рио-дас-Острас" },
  Hangzhou: { uk: "Ханчжоу", ru: "Ханчжоу" },
  "San Jose": { uk: "Сан-Хосе", ru: "Сан-Хосе" },
  Alexandria: { uk: "Олександрія", ru: "Александрия" },
  Zlatibor: { uk: "Златибор", ru: "Златибор" },
  "Naberezhnyye Chelny": { uk: "Набережні Челни", ru: "Набережные Челны" },
  Salvador: { uk: "Сальвадор", ru: "Сальвадор" },
  "Krasnaya Pakhra": { uk: "Красна Пахра", ru: "Красная Пахра" },
  Lunel: { uk: "Люне", ru: "Люне" },
  Newport: { uk: "Ньюпорт", ru: "Ньюпорт" },
  Vienna: { uk: "Відень", ru: "Вена" },
  "São Sebastião do Passé": {
    uk: "Сан-Себастьян-ду-Пасе",
    ru: "Сан-Себастьян-ду-Пасе",
  },
  Kharkiv: { uk: "Харків", ru: "Харьков" },
  Brisbane: {
    uk: "Брісбен",
    ru: "Брисбен",
  },
  Phoenix: { uk: "Фінікс", ru: "Феникс" },
  Slough: { uk: "Слоу", ru: "Слау" },
  Meerut: { uk: "Меерут", ru: "Меерут" },
  "Cape Coast": { uk: "Кейп-Кост", ru: "Кейп-Кост" },
  Falkenstein: { uk: "Фалькенштайн", ru: "Фалькенштайн" },
  "Chon Buri": { uk: "Чонбурі", ru: "Чонбури" },
  "Rio de Janeiro": { uk: "Ріо-де-Жанейро", ru: "Рио-де-Жанейро" },
  Žilina: { uk: "Жиліна", ru: "Жилина" },
  Mărăcineni: { uk: "Марачінень", ru: "Марачинень" },
  "Kazan'": { uk: "Казань", ru: "Казань" },
  "Karet Kuningan": { uk: "Карет Кунінган", ru: "Карет Кунинган" },
  Mumbai: { uk: "Мумбаї", ru: "Мумбаи" },
  "Kansas City": { uk: "Канзас-Сіті", ru: "Канзас-Сити" },
  Sathyamangalam: { uk: "Сатіямангалам", ru: "Сатиямангалам" },
  Piraí: { uk: "Пірай", ru: "Пираи" },
  Kigali: { uk: "Кігалі", ru: "Кигали" },
  Bangkok: { uk: "Бангкок", ru: "Бангкок" },
  Caracas: { uk: "Каракас", ru: "Каракас" },
  "San Bernardino": { uk: "Сан-Бернардіно", ru: "Сан-Бернардино" },
  "Ho Chi Minh City": { uk: "Хошимін", ru: "Хошимин" },
  Bryansk: { uk: "Брянськ", ru: "Брянск" },
  "Tsuzuki Ku": { uk: "Цудзукі-ку", ru: "Цудзуки-ку" },
  Pune: { uk: "Пуна", ru: "Пуна" },
  Middletown: { uk: "Міддлтаун", ru: "Миддлтаун" },
  Istanbul: { uk: "Стамбул", ru: "Стамбул" },
  Queens: { uk: "Квінз", ru: "Квинс" },
  "Kampong Loyang": { uk: "Кампунг Лоянг", ru: "Кампунг Лоянг" },
  Boardman: { uk: "Бордеман", ru: "Бордеман" },
  Antakya: { uk: "Антакія", ru: "Антакья" },
  Bondoufle: { uk: "Бондуфль", ru: "Бондуфль" },
  Shkodër: { uk: "Шкодер", ru: "Шкодер" },
  Washington: { uk: "Вашингтон", ru: "Вашингтон" },
  Zhangzhou: { uk: "Чжанчжоу", ru: "Чжанчжоу" },
  Osaka: { uk: "Осака", ru: "Осака" },
  Goiânia: { uk: "Гоянія", ru: "Гояния" },
  "Frankfurt am Main": { uk: "Франкфурт-на-Майні", ru: "Франкфурт-на-Майне" },
  Strelcha: { uk: "Стрельча", ru: "Стрельча" },
  Bekasi: { uk: "Бекасі", ru: "Бекаси" },
  Toronto: { uk: "Торонто", ru: "Торонто" },
  Wroclaw: { uk: "Вроцлав", ru: "Вроцлав" },
  Nicosia: { uk: "Нікосія", ru: "Никосия" },
  "New Taipei City": { uk: "Нове Тайбей", ru: "Новый Тайбэй" },
  Caruaru: { uk: "Каруару", ru: "Каруару" },
  "Bom Sucesso": { uk: "Бом-Сусесо", ru: "Бом-Сусесо" },
  Sens: { uk: "Сен", ru: "Сен" },
  Mangalore: { uk: "Мангалор", ru: "Мангалар" },
  Shahhat: { uk: "Шаххат", ru: "Шаххат" },
  "Banja Luka": { uk: "Баня-Лука", ru: "Баня-Лука" },
  Dallas: { uk: "Даллас", ru: "Даллас" },
  Jombang: { uk: "Йомбанг", ru: "Йомбанг" },
  Yangzhou: { uk: "Янчжоу", ru: "Янчжоу" },
  Renton: { uk: "Рентон", ru: "Рентон" },
  Cirebon: { uk: "Чіребон", ru: "Чиребон" },
  Stockach: { uk: "Штоках", ru: "Штоках" },
  Paris: { uk: "Париж", ru: "Париж" },
  Ōtsu: { uk: "Оцу", ru: "Оцу" },
  Geneva: { uk: "Женева", ru: "Женева" },
  "Hong Kong": { uk: "Гонконг", ru: "Гонконг" },
  Fukuyama: { uk: "Фукуяма", ru: "Фукуяма" },
  "Santa Cruz": { uk: "Санта-Крус", ru: "Санта-Крус" },
  "Villa Ballester": { uk: "Вілья-Бальєстер", ru: "Вилья-Бальестер" },
  Atlanta: { uk: "Атланта", ru: "Атланта" },
  Rayong: { uk: "Районг", ru: "Районг" },
  "Santa Clara": { uk: "Санта-Клара", ru: "Санта-Клара" },
  Vientiane: { uk: "В'єнтян", ru: "Вьєнтян" },
  Chuncheon: { uk: "Чунчхон", ru: "Чунчхон" },
  "San José": { uk: "Сан-Хосе", ru: "Сан-Хосе" },
  Seville: { uk: "Севілья", ru: "Севилья" },
  Taipei: { uk: "Тайбей", ru: "Тайбэй" },
  Montreal: { uk: "Монреаль", ru: "Монреаль" },
  Ińsko: { uk: "Інсько", ru: "Инсько" },
  "Montes Claros": { uk: "Монтес-Кларос", ru: "Монтес-Кларос" },
  "Santo Domingo": { uk: "Санто-Домінго", ru: "Санто-Доминго" },
  Damascus: { uk: "Дамаск", ru: "Дамаск" },
  Kaunas: { uk: "Каунас", ru: "Каунас" },
  Hopetown: { uk: "Хоптаун", ru: "Хоптаун" },
  Haldia: { uk: "Хальдія", ru: "Хальдия" },
  Copenhagen: { uk: "Копенгаген", ru: "Копенгаген" },
  Malang: { uk: "Маланг", ru: "Маланг" },
  "Jiménez Municipality": {
    uk: "Муніципалітет Хіменес",
    ru: "Муниципалитет Хименес",
  },
  Surabaya: { uk: "Сурабая", ru: "Сурабая" },
  Cabimas: { uk: "Кабімас", ru: "Кабимас" },
  Valledupar: { uk: "Вальєдупар", ru: "Вальедупар" },
  Portsmouth: { uk: "Портсмут", ru: "Портсмут" },
  "North Charleston": { uk: "Північний Чарлстон", ru: "Северный Чарлстон" },
  Paju: { uk: "Паджу", ru: "Паджу" },
  Banyumas: { uk: "Банюмас", ru: "Банюмас" },
  Sulaymaniyah: { uk: "Сулейманія", ru: "Сулеймания" },
  Amman: { uk: "Амман", ru: "Амман" },
  Seoul: { uk: "Сеул", ru: "Сеул" },
  Uman: { uk: "Умань", ru: "Умань" },
  Hamadan: { uk: "Хамадан", ru: "Хамадан" },
  Medan: { uk: "Медан", ru: "Медан" },
  Tampa: { uk: "Тампа", ru: "Тампа" },
  "São Francisco do Sul": {
    uk: "Сан-Франциско-ду-Сул",
    ru: "Сан-Франциско-ду-Сул",
  },
  Dhaka: { uk: "Дакка", ru: "Дакка" },
  Tbilisi: { uk: "Тбілісі", ru: "Тбилиси" },
  Düsseldorf: { uk: "Дюссельдорф", ru: "Дюссельдорф" },
  "San Gil": { uk: "Сан-Гіл", ru: "Сан-Гил" },
  Amsterdam: { uk: "Амстердам", ru: "Амстердам" },
  "Buenos Aires": { uk: "Буенос-Айрес", ru: "Буэнос-Айрес" },
  Preševo: { uk: "Прешево", ru: "Прешево" },
  Bogotá: { uk: "Богота", ru: "Богота" },
  Vijayawada: { uk: "Віджаявада", ru: "Виджаявада" },
  "St. François Xavier": { uk: "Сен-Франсуа-Ксав'є", ru: "Сен-Франсуа-Ксавье" },
  Temuco: { uk: "Темучо", ru: "Темучо" },
  Moroleón: { uk: "Моролеон", ru: "Моролеон" },
  "Elk Grove Village": { uk: "Село Елк-Гров", ru: "Село Елк-Гров" },
  "Benito Juárez": { uk: "Беніто Хуарес", ru: "Бенито Хуарес" },
  Pasig: { uk: "Пасіг", ru: "Пасиг" },
  Pengarengan: { uk: "Пенгаранген", ru: "Пенгаранген" },
  Singapore: { uk: "Сінгапур", ru: "Сингапур" },
  Poznan: { uk: "Познань", ru: "Познань" },
  "Santa Rosa": { uk: "Санта-Роза", ru: "Санта-Роза" },
  Miami: { uk: "Маямі", ru: "Майами" },
  "New York": { uk: "Нью-Йорк", ru: "Нью-Йорк" },
  Guayaquil: { uk: "Гуаякіль", ru: "Гуаякиль" },
  Banyuwangi: { uk: "Баньювангі", ru: "Баньюванги" },
  Manizales: { uk: "Манісалес", ru: "Манисалес" },
  Jaicós: { uk: "Хайкос", ru: "Хайкос" },
  "Santa Helena": { uk: "Санта-Гелена", ru: "Санта-Хелена" },
  Kyiv: { uk: "Київ", ru: "Киев" },
  Ashburn: { uk: "Ашберн", ru: "Ашберн" },
  Pozantı: { uk: "Позанти", ru: "Позанти" },
  "Purwodadi Grobogan": { uk: "Пурводаді Гробоган", ru: "Пурводаді Гробоган" },
  Duhok: { uk: "Духок", ru: "Духок" },
  "Porto Seguro": { uk: "Порту-Сегуро", ru: "Порту-Сегуро" },
  Weehawken: { uk: "Віхаукен", ru: "Вихаукен" },
  London: { uk: "Лондон", ru: "Лондон" },
  Tashkent: { uk: "Ташкент", ru: "Ташкент" },
  Chillán: { uk: "Чіллан", ru: "Чиллан" },
  Girona: { uk: "Жирона", ru: "Жирона" },
  Renca: { uk: "Ренка", ru: "Ренка" },
  "Council Bluffs": { uk: "Кансел-Блаффс", ru: "Кансел-Блаффс" },
  Bengaluru: { uk: "Бенгалуру", ru: "Бенгалуру" },
  Khomutovo: { uk: "Хомутово", ru: "Хомутово" },
  Helsinki: { uk: "Гельсінкі", ru: "Хелсинки" },
  Pekanbaru: { uk: "Пеканбару", ru: "Пеканбару" },
  Beijing: { uk: "Пекін", ru: "Пекин" },
  Barranquilla: { uk: "Барранкілья", ru: "Барранкилья" },
  "Hwaseong-si": { uk: "Хвасонг-си", ru: "Хвасонг-си" },
  Sukabumi: { uk: "Сукабумі", ru: "Sukabumi" },
  Quito: { uk: "Кіто", ru: "Кито" },
  Lamongan: { uk: "Ламонган", ru: "Ламонган" },
  Jember: { uk: "Джамбер", ru: "Джамбер" },
  Pasuruan: { uk: "Пасуруан", ru: "Пасуруан" },
  Loudi: { uk: "Лоуді", ru: "Лоуди" },
  Wanaherang: { uk: "Ванахеранг", ru: "Ванахеранг" },
  "Concepción de la Vega": {
    uk: "Консепсьйон-де-ла-Вега",
    ru: "Консепсьйон-де-ла-Вега",
  },
  Majalengka: { uk: "Маджаленка", ru: "Маджаленка" },
  Zurich: { uk: "Цюрих", ru: "Цюрих" },
  "Guatemala City": { uk: "Гватемала Сіті", ru: "Город Гватемала" },
  Talagante: { uk: "Талаганте", ru: "Талаганте" },
  Nairobi: { uk: "Найробі", ru: "Найроби" },
  Arequipa: { uk: "Арекіпа", ru: "Арекипа" },
  Montemorelos: { uk: "Монтеморелос", ru: "Монтеморелос" },
  Abidjan: { uk: "Абіджан", ru: "Абиджан" },
  Bhubaneswar: { uk: "Бхубанешвар", ru: "Бхубанешвар" },
  Purbalingga: { uk: "Пурбалінгга", ru: "Пурбалингга" },
  Khmelnytskyi: { uk: "Хмельницький", ru: "Хмельницкий" },
  Sragen: { uk: "Сраген", ru: "Сраген" },
  Porto: { uk: "Порту", ru: "Порту" },
  Krasnoyarsk: { uk: "Красноярськ", ru: "Красноярск" },
  Thāne: { uk: "Тане", ru: "Тхане" },
  Bujumbura: { uk: "Бужумбура", ru: "Бужумбура" },
  Keputih: { uk: "Кепутіх", ru: "Кепутий" },
  Gaborone: { uk: "Габороне", ru: "Габороне" },
  Rosario: { uk: "Росаріо", ru: "Росарио" },
  "Seongbuk-gu": { uk: "Сеонгбук-гу", ru: "Сонбук-гу" },
  "La Zenia": { uk: "Ла Зенія", ru: "Ла-Сения" },
  Salatiga: { uk: "Салатіга", ru: "Салатига" },
  Ikeda: { uk: "Ікеда", ru: "Икеда" },
  Tegal: { uk: "Тегал", ru: "Тегал" },
  Yogyakarta: { uk: "Йог'якарта", ru: "Джокьякарта" },
  Comitán: { uk: "Комітан", ru: "Комитан" },
  Indore: { uk: "Індор", ru: "Индор" },
  Cimahi: { uk: "Чімахі", ru: "Чимахи" },
  Multan: { uk: "Мултан", ru: "Мултан" },
  "Livry-Gargan": { uk: "Ліврі-Гарган", ru: "Ливри-Гарган" },
  Schwerte: { uk: "Шверте", ru: "Шверте" },
  Weleri: { uk: "Велері", ru: "Велери" },
  Simalungun: { uk: "Сімалунгун", ru: "Сималунгун" },
  "Duri Pulo": { uk: "Дурі-Пуло", ru: "Дури-Пуло" },
  "Jambi City": { uk: "Місто Джамбі", ru: "Город Джамби" },
  Macon: { uk: "Макон", ru: "Макон" },
  Sheffield: { uk: "Шеффілд", ru: "Шеффилд" },
  Johannesburg: { uk: "Йоганнесбург", ru: "Йоханнесбург" },
  Tehran: { uk: "Тегеран", ru: "Тегеран" },
  Ibagué: { uk: "Ібаге", ru: "Ибаге" },
  Orangeburg: { uk: "Оранжбург", ru: "Оранжбург" },
  "Los Angeles": { uk: "Лос-Анджелес", ru: "Лос-Анджелес" },
  "Coronel Juan Solá": { uk: "Коронель Хуан Сола", ru: "Коронель Хуан Сола" },
  "Las Cabras": { uk: "Лас-Кабрас", ru: "Лас-Кабрас" },
  Blida: { uk: "Бліда", ru: "Блида" },
  Cawang: { uk: "Каванг", ru: "Каванг" },
  Algiers: { uk: "Алжир", ru: "Алжир" },
  "Cape Town": { uk: "Кейптаун", ru: "Кейптаун" },
  Drohobych: { uk: "Дрогобич", ru: "Дрогобыч" },
  Boyolali: { uk: "Бойолалі", ru: "Бойолали" },
  Dobrich: { uk: "Добрич", ru: "Добрич" },
  Giza: { uk: "Гіза", ru: "Гиза" },
  Noáin: { uk: "Ноайн", ru: "Ноайн" },
  "Cagayan de Oro": { uk: "Кагаян-де-Оро", ru: "Кагаян-де-Оро" },
  Tigbauan: { uk: "Тігбауан", ru: "Тигбауан" },
  "São Bernardo do Campo": {
    uk: "Сан-Бернардо-ду-Кампо",
    ru: "Сан-Бернардо-ду-Кампо",
  },
  Buffalo: { uk: "Буффало", ru: "Буффало" },
  "Bang Bua Thong": { uk: "Банг Буа Тонг", ru: "Банг Буа Тонг" },
  Cúcuta: { uk: "Кукута", ru: "Кукута" },
  Nitra: { uk: "Нітра", ru: "Нитра" },
  Bandung: { uk: "Бандунг", ru: "Бандунг" },
  "Nova Iguaçu": { uk: "Нова Ігуасу", ru: "Нова Игуасу" },
  "St Louis": { uk: "Сент-Луїс", ru: "Сент-Луис" },
  "Santa Ana": { uk: "Санта-Анна", ru: "Санта-Анна" },
  Reston: { uk: "Рестон", ru: "Рестон" },
  Kuwana: { uk: "Кувана", ru: "Кувана" },
  "Phumĭ Kândal": { uk: "Фум Кандал", ru: "Фум Кандал" },
  "Maisons-Alfort": { uk: "Мезон-Альфор", ru: "Мезон-Альфор" },
  "Nakhon Sawan": { uk: "Након Саван", ru: "Након Саван" },
  Guarenas: { uk: "Гуаранес", ru: "Гуаранес" },
  Neiva: { uk: "Нейва", ru: "Нейва" },
  Shaoxing: { uk: "Шаосін", ru: "Шаосин" },
  Muscat: { uk: "Маскат", ru: "Маскат" },
  Asunción: { uk: "Асунсьйон", ru: "Асунсьйон" },
  "Ulan-Ude": { uk: "Улан-Уде", ru: "Улан-Уде" },
  "Kota Kinabalu": { uk: "Кота-Кінабалю", ru: "Кота-Кинабалу" },
  "Las Vegas": { uk: "Лас-Вегас", ru: "Лас-Вегас" },
  Makassar: { uk: "Макасар", ru: "Маккасар" },
  Campinas: { uk: "Кампініс", ru: "Кампинис" },
  Menteng: { uk: "Ментенг", ru: "Ментенг" },
  Apodaca: { uk: "Аподака", ru: "Аподака" },
  Palma: { uk: "Пальма", ru: "Пальма" },
  Khasavyurt: { uk: "Хасавюрт", ru: "Хасавюрт" },
  "Porto Alegre": { uk: "Порту-Алегре", ru: "Порту-Алегре" },
  Dubai: { uk: "Дубай", ru: "Дубай" },
  Batang: { uk: "Батанг", ru: "Батанг" },
  Reyhanlı: { uk: "Рейханли", ru: "Рейханлы" },
  Theni: { uk: "Тхені", ru: "Тхени" },
  Kathmandu: { uk: "Катманду", ru: "Катманду" },
  "Suseong-gu": { uk: "Сусонг-гу", ru: "Сусонг-гу" },
  "Da Nang": { uk: "Да Нанг", ru: "Да Нанг" },
  Novosibirsk: { uk: "Новосибірськ", ru: "Новосибирск" },
  Dakar: { uk: "Дакар", ru: "Дакар" },
  "San Francisco": { uk: "Сан-Франциско", ru: "Сан-Франциско" },
  Karawang: { uk: "Караванг", ru: "Караванг" },
  Lima: { uk: "Ліма", ru: "Лима" },
  Indramayu: { uk: "Індрамаю", ru: "Индрамаю" },
  Rodriguez: { uk: "Родрігес", ru: "Родригес" },
  "Seo-gu": { uk: "Сео-гу", ru: "Сео-гу" },
  Jacksonville: { uk: "Джексонвіль", ru: "Джексонвиль" },
  Machala: { uk: "Мачала", ru: "Мачала" },
  Zhubei: { uk: "Чжубей", ru: "Чжубей" },
  Hyderabad: { uk: "Хайдарабад", ru: "Хайдарабад" },
  "Tanjung Balai": { uk: "Танджунг-Балай", ru: "Танджунг-Балай" },
  Loja: { uk: "Лоха", ru: "Лоха" },
  "O'Fallon": { uk: "О'Фаллон", ru: "О'Фаллон" },
  Posadas: { uk: "Посадас", ru: "Посадас" },
  Budapest: { uk: "Будапешт", ru: "Будапешт" },
  Morādābād: { uk: "Морадабад", ru: "Морадабад" },
  Sydney: { uk: "Сідней", ru: "Сидней" },
  Taichung: { uk: "Тайчжун", ru: "Тайчжун" },
  Fremont: { uk: "Фрімонт", ru: "Фримонт" },
  Gwangju: { uk: "Кванджу", ru: "Кванджу" },
  Sejong: { uk: "Седжон", ru: "Седжон" },
  Tianjin: { uk: "Тяньцзінь", ru: "Тяньцзинь" },
  Wonosobo: { uk: "Вонособо", ru: "Вонособо" },
  Creston: { uk: "Крестон", ru: "Крестон" },
  Philadelphia: { uk: "Філадельфія", ru: "Филадельфия" },
  Biysk: { uk: "Бійськ", ru: "Бийск" },
  Crixás: { uk: "Кріксас", ru: "Криксас" },
  "Agustin Codazzi": { uk: "Агустін Кодазі", ru: "Агустин Кодази" },
  Subang: { uk: "Субанг", ru: "Субанг" },
  Changzhou: { uk: "Чанжоу", ru: "Чанжоу" },
  Linz: { uk: "Лінц", ru: "Линц" },
  "Tam Kỳ": { uk: "Там-Кі", ru: "Там-Ки" },
  Rāwatbhāta: { uk: "Раватбхата", ru: "Раватбхата" },
  Ternopil: { uk: "Тернопіль", ru: "Тернополь" },
  "São Luís": { uk: "Сан-Луїс", ru: "Сан-Луис" },
  "Aix-en-Provence": { uk: "Екс-ан-Прованс", ru: "Экс-ан-Прованс" },
  "Villa Ángela": { uk: "Вілла-Анджела", ru: "Вилла-Анджела" },
  Jundiaí: { uk: "Жундіаї", ru: "Жундиаи" },
  Karbala: { uk: "Кербела", ru: "Кербела" },
  "Kebumen Satu": { uk: "Кебумен Сату", ru: "Кебумен Сату" },
  Naaldwijk: { uk: "Наалдвік", ru: "Наалдвик" },
  "Ha Kwai Chung": { uk: "Ха-Квай-Чунг", ru: "Ха-Квай-Чунг" },
  Cajazeiras: { uk: "Кахасейрас", ru: "Кахасейрас" },
  Daegu: { uk: "Тегу", ru: "Тэгу" },
  Catanduvas: { uk: "Катандувас", ru: "Катандувас" },
  Yunlin: { uk: "Юнлін", ru: "Юнлин" },
  Caririaçu: { uk: "Каріріасу", ru: "Каририасу" },
  Lviv: { uk: "Львів", ru: "Львов" },
  Prague: { uk: "Прага", ru: "Прага" },
  "Puerto López": { uk: "Пуерто-Лопес", ru: "Пуэрто-Лопес" },
  Chañaral: { uk: "Чанарал", ru: "Чанарал" },
  Pagadian: { uk: "Пагадіан", ru: "Пагадиан" },
  Bungarribee: { uk: "Бунгарібі", ru: "Бунгариби" },
  Tijuana: { uk: "Тіхуана", ru: "Тихуана" },
  Piscataway: { uk: "Піскатауей", ru: "Пискатауэй" },
  "Nueva Loja": { uk: "Нью-Лоха", ru: "Нью-Лоха" },
  Ajmer: { uk: "Аджмер", ru: "Аджмер" },
  Orito: { uk: "Оріто", ru: "Орито" },
  Pandeglang: { uk: "Пандегланг", ru: "Пандегланг" },
  Alba: { uk: "Альба", ru: "Альба" },
  Chicago: { uk: "Чикаго", ru: "Чикаго" },
  "Estancia Nueva Esperanza": {
    uk: "Естансія Нова Есперанса",
    ru: "Эстансия Нова Эсперанса",
  },
  Temanggung: { uk: "Темангунг", ru: "Темангунг" },
  Chimbote: { uk: "Чімботе", ru: "Чимботе" },
  Pasto: { uk: "Пасто", ru: "Пасто" },
  Xiangtan: { uk: "Сянгтан", ru: "Сянгтан" },
  Tirupur: { uk: "Тірупур", ru: "Тирупур" },
  Vladimir: { uk: "Володимир", ru: "Владимир" },
  Khorol: { uk: "Хорол", ru: "Хорол" },
  Zhytomyr: { uk: "Житомир", ru: "Житомир" },
  Miranda: { uk: "Міранда", ru: "Миранда" },
  Brebes: { uk: "Бребес", ru: "Бребес" },
  "Santa Fe": { uk: "Санта-Фе", ru: "Санта-Фе" },
  Garín: { uk: "Гарін", ru: "Гарин" },
  Milan: { uk: "Мілан", ru: "Милан" },
  Purwakarta: { uk: "Пурвакарта", ru: "Пурвакарта" },
  Baltimore: { uk: "Балтимор", ru: "Балтимор" },
  Delhi: { uk: "Делі", ru: "Дели" },
  Chennai: { uk: "Ченнай", ru: "Ченнай" },
  Ostrava: { uk: "Острава", ru: "Острава" },
  "Dar es Salaam": { uk: "Дар-ес-Салам", ru: "Дар-эс-Салам" },
  "Cikarang Satu": { uk: "Чікаранг Сату", ru: "Чикаранг Сату" },
  Vancouver: { uk: "Ванкувер", ru: "Ванкувер" },
  Accra: { uk: "Аккра", ru: "Аккра" },
  "Saint-Clément-de-Valorgue": {
    uk: "Сен-Клеман-де-Валорг",
    ru: "Сен-Клеман-де-Валорг",
  },
  Stockholm: { uk: "Стокгольм", ru: "Стокгольм" },
  Boston: { uk: "Бостон", ru: "Бостон" },
  Kawahara: { uk: "Кавахара", ru: "Кавахара" },
  Asheville: { uk: "Ашвілл", ru: "Ашвилл" },
  "Al Ma`adi": { uk: "Ель-Мааді", ru: "Эль-Маади" },
  Manila: { uk: "Маніла", ru: "Манила" },
  "Kuala Lumpur": { uk: "Куала-Лумпур", ru: "Куала-Лумпур" },
  "Limburg an der Lahn": { uk: "Лімбург на Лані", ru: "Лимбург на Лане" },
  Hillsboro: { uk: "Гіллсборо", ru: "Гиллсборо" },
  Strasbourg: { uk: "Страсбург", ru: "Страсбург" },
  Surakarta: { uk: "Суракарта", ru: "Суракарта" },
  Toulouse: { uk: "Тулуз", ru: "Тулуза" },
  Bogor: { uk: "Богор", ru: "Богор" },
  Blitar: { uk: "Блітар", ru: "Блитар" },
  Baghdad: { uk: "Багдад", ru: "Багдад" },
  "Cedar Knolls": { uk: "Седар-Ноллс", ru: "Седар-Ноллс" },
  Berlin: { uk: "Берлін", ru: "Берлин" },
  Brussels: { uk: "Брюссель", ru: "Брюссель" },
  Ponorogo: { uk: "Понорого", ru: "Понорого" },
  Batam: { uk: "Батам", ru: "Батам" },
  Aylesbury: { uk: "Ейлсбері", ru: "Эйлсбери" },
  Bexleyheath: { uk: "Бексліхіт", ru: "Бекслихит" },
  Ratchaburi: { uk: "Рачабурі", ru: "Рачабури" },
  Brasiléia: { uk: "Бразилея", ru: "Бразилея" },
  "Presidente Prudente": {
    uk: "Президенти Пруденте",
    ru: "Президенти Пруденте",
  },
  "La Guaira": { uk: "Ла-Гваїра", ru: "Ла-Гвайра" },
  Teno: { uk: "Тено", ru: "Тено" },
  Kinshasa: { uk: "Кіншаса", ru: "Киншаса" },
  Minatomirai: { uk: "Мінатоміраї", ru: "Минатомираи" },
  Villejuif: { uk: "Вільежиф", ru: "Вильежиф" },
  Nagoya: { uk: "Нагоя", ru: "Нагоя" },
  Chittagong: { uk: "Читтагонг", ru: "Читтагонг" },
  Guaymas: { uk: "Гуаймас", ru: "Гуаймас" },
  Araranguá: { uk: "Арарангу", ru: "Арарангу" },
  Osorno: { uk: "Осорно", ru: "Осорно" },
  "Lys'va": { uk: "Лисва", ru: "Лысва" },
  "Khlong Luang": { uk: "Клонг-Луан", ru: "Клонг-Луан" },
  "San Javier": { uk: "Сан-Хав'єр", ru: "Сан-Хавьер" },
  Maracaibo: { uk: "Маракайбо", ru: "Маракайбо" },
  Medellín: { uk: "Медельїн", ru: "Медельин" },
  "Cruzeiro do Oeste": { uk: "Крузейро-ду-Оесте", ru: "Крузейро-ду-Оесте" },
  "10th of Ramadan City": {
    uk: "Місто 10-го Рамадану",
    ru: "Місто 10-го Рамадану",
  },
  "El Carmen": { uk: "Ель-Кармен", ru: "Эль-Кармен" },
  Odesa: { uk: "Одеса", ru: "Одесса" },
  Panipat: { uk: "Паніпат", ru: "Панипат" },
  Brody: { uk: "Броди", ru: "Броди" },
  "San Cristóbal": { uk: "Сан-Крістобаль", ru: "Сан-Кристобаль" },
  Köseköy: { uk: "Кьосекьой", ru: "Кьосекёй" },
  "San José del Guaviare": {
    uk: "Сан-Хосе-дель-Гуавіар",
    ru: "Сан-Хосе-дель-Гуавиар",
  },
  "Santander de Quilichao": {
    uk: "Сантадер-де-Квілічао",
    ru: "Сантадер-де-Квиличао",
  },
  Porlamar: { uk: "Порламар", ru: "Порламар" },
  Changsha: { uk: "Чанша", ru: "Чанша" },
  Elpitiya: { uk: "Елпитія", ru: "Элпития" },
  Erbil: { uk: "Ербіль", ru: "Эрбиль" },
  "Chervone Pole": { uk: "Червоне Поле", ru: "Червоное Поле" },
  "Monte Mor": { uk: "Монте-Мор", ru: "Монте-Мор" },
  Pābna: { uk: "Пабна", ru: "Пабна" },
  Pensacola: { uk: "Пенсакола", ru: "Пенсакола" },
  Paracatu: { uk: "Паракату", ru: "Паракату" },
  Rzeszów: { uk: "Жешув", ru: "Жешув" },
  Shelby: { uk: "Шелбі", ru: "Шелби" },
  "Santa Maria de Jetibá": {
    uk: "Санта-Марія-де-Хетиба",
    ru: "Санта-Мария-де-Жетиба",
  },
  "Pato Branco": { uk: "Пато-Бранко", ru: "Пато-Бранко" },
  Changchun: { uk: "Чанчунь", ru: "Чанчунь" },
  Hörstel: { uk: "Герстель", ru: "Герстель" },
  Gianyar: { uk: "Джіаняр", ru: "Джианьяр" },
  Lopburi: { uk: "Лопбурі", ru: "Лопбури" },
  Bucharest: { uk: "Бухарест", ru: "Бухарест" },
  Incheon: { uk: "Інчхон", ru: "Инчхон" },
  Raipur: { uk: "Райпур", ru: "Райпур" },
  Tuluá: { uk: "Тулуа", ru: "Тулуа" },
  Biskupiec: { uk: "Бископець", ru: "Бископец" },
  "City of Westminster": { uk: "Місто Вестмінстер", ru: "Город Вестминстер" },
  Horntown: { uk: "Горнтаун", ru: "Хорнтаун" },
  Tasikmalaya: { uk: "Тасікмалая", ru: "Тасикмалая" },
  Harmelen: { uk: "Гарменлен", ru: "Гарменлен" },
  "Hải Dương": { uk: "Хай-Дуонг", ru: "Хай-Дуонг" },
  Kupang: { uk: "Купанг", ru: "Купанг" },
  "Boa Vista": { uk: "Боа Віста", ru: "Боа Виста" },
  Irkutsk: { uk: "Іркутськ", ru: "Иркутск" },
  "Yerba Buena": { uk: "Єрба-Буена", ru: "Ерба-Буена" },
  Guiyang: { uk: "Гуйян", ru: "Гуйян" },
  Lodz: { uk: "Лодзь", ru: "Лодзь" },
  Gangneung: { uk: "Гангнунг", ru: "Гангнунг" },
  Yola: { uk: "Йола", ru: "Йола" },
  "The Dalles": { uk: "Далес", ru: "Далес" },
  Kunming: { uk: "Куньмін", ru: "Куньмин" },
  "Yongin-si": { uk: "Йонгін-сі", ru: "Йонгин-си" },
  Vyshhorod: { uk: "Вишгород", ru: "Вышгород" },
  Nanning: { uk: "Наньнін", ru: "Наннинг" },
  Cergy: { uk: "Серджі", ru: "Сержи" },
  Ningxia: { uk: "Нінся", ru: "Нинся" },
  "Zhongli District": { uk: "Район Чжунлі", ru: "Район Чжунли" },
  Kingston: { uk: "Кінгстон", ru: "Кингстон" },
  "Phanat Nikhom": { uk: "Фанат Нікхом", ru: "Фанат Никхом" },
  "Guanajuato City": { uk: "Місто Гуанахуато", ru: "Город Гуанахуато" },
  Gambrills: { uk: "Гамбріллс", ru: "Гамбрилс" },
  Żagań: { uk: "Жагань", ru: "Жаган" },
  Drezna: { uk: "Дрезна", ru: "Дрезна" },
  Ashgabat: { uk: "Ашгабат", ru: "Ашхабад" },
  Teresina: { uk: "Терезіна", ru: "Терезина" },
  Kaohsiung: { uk: "Кауосюн", ru: "Каошюн" },
  "Busanjin-gu": { uk: "Бусанджин-гу", ru: "Бусанжин-гу" },
  Namyangju: { uk: "Намянджу", ru: "Намянджу" },
  "Goyang-si": { uk: "Гоянг-сі", ru: "Гоянг-си" },
  Fuzhou: { uk: "Фучжоу", ru: "Фучжоу" },
  "Yuseong-gu": { uk: "Юсінг-гу", ru: "Юсинг-гу" },
  "Luis Eduardo Magalhães": {
    uk: "Луїс Едуардо Магальяс",
    ru: "Луис Эдуардо Магальяс",
  },
  Belgorod: { uk: "Бєлгород", ru: "Белгород" },
  Athens: { uk: "Афіни", ru: "Афины" },
  Suez: { uk: "Суец", ru: "Суэц" },
  Tegucigalpa: { uk: "Тегусігальпа", ru: "Тегусигальпа" },
  Bata: { uk: "Бата", ru: "Бата" },
  "Campo Grande": { uk: "Кампо-Гранде", ru: "Кампо-Гранде" },
  "Phra Nakhon Si Ayutthaya": {
    uk: "Пхра Након Сі Аюттхая",
    ru: "Пхра Након Си Аюттхая",
  },
  Pati: { uk: "Паті", ru: "Пати" },
  "Tekovské Lužany": { uk: "Тековські Лужани", ru: "Тековске Лужаны" },
  Tumaco: { uk: "Тумака", ru: "Тумака" },
  Noida: { uk: "Ноіда", ru: "Ноида" },
  Khulna: { uk: "Хулна", ru: "Хулна" },
  Klaten: { uk: "Клатен", ru: "Клатен" },
  Rustenburg: { uk: "Рустенбург", ru: "Рустенбург" },
  Madrid: { uk: "Мадрид", ru: "Мадрид" },
  Princeton: { uk: "Прінстон", ru: "Принстон" },
  "Valle de La Pascua": { uk: "Валле-де-Ла-Паскуа", ru: "Валье-де-Ла-Паскуа" },
  Phetchaburi: { uk: "Пхетчабурі", ru: "Пхетчабури" },
  Mikulov: { uk: "Мікулов", ru: "Микулов" },
  Bishkek: { uk: "Бішкек", ru: "Бишкек" },
  İskenderun: { uk: "Іскендерун", ru: "Искендерун" },
  Suwon: { uk: "Сувон", ru: "Сувон" },
  Inzai: { uk: "Індзаї", ru: "Индзай" },
  Barrancabermeja: { uk: "Барранкабермея", ru: "Барранкабермеха" },
  Tulungagung: { uk: "Тулунгагунг", ru: "Тулунгагунг" },
  Recife: { uk: "Ресіфе", ru: "Ресифи" },
  "Puerto Juárez": { uk: "Пуерто-Хуарес", ru: "Пуэрто-Хуарес" },
  Dharapuram: { uk: "Дхарапура", ru: "Дхарапура" },
  Nelspruit: { uk: "Нелспріт", ru: "Нелсприт" },
  Harare: { uk: "Хараре", ru: "Хараре" },
  "Puente Alto": { uk: "Пуенте-Альто", ru: "Пуенте-Альто" },
  "Tres de Febrero": { uk: "Трес-де-Фебреро", ru: "Трес-де-Фебреро" },
  Magetan: { uk: "Маджетан", ru: "Маджетан" },
  Gaziantep: { uk: "Газіантеп", ru: "Газиантеп" },
  Kediri: { uk: "Кедірі", ru: "Кедири" },
  Cartagena: { uk: "Картagena", ru: "Картахена" },
  "Changwat Sara Buri": { uk: "Чанват Сарабурі", ru: "Чангват Сарабури" },
  Dobrevtsi: { uk: "Добрівці", ru: "Добревци" },
  Yerevan: { uk: "Єреван", ru: "Ереван" },
  Patu: { uk: "Пату", ru: "Пату" },
  Xinyu: { uk: "Сінью", ru: "Синью" },
  Dombivali: { uk: "Домбіва", ru: "Домбива" },
  Pakenham: { uk: "Пакенгем", ru: "Пакенхэм" },
  Noākhāli: { uk: "Ноакхалі", ru: "Ноахали" },
  Madurai: { uk: "Мадурай", ru: "Мадурай" },
  "Arraial do Cabo": { uk: "Аррайал-до-Кабо", ru: "Аррайал-до-Кабо" },
  Yekaterinburg: { uk: "Єкатеринбург", ru: "Екатеринбург" },
  Florence: { uk: "Флоренція", ru: "Флоренция" },
  Yablonovsky: { uk: "Яблонівський", ru: "Яблоновский" },
  Yondó: { uk: "Йондо", ru: "Йондо" },
  Lākshām: { uk: "Лакшам", ru: "Лакшам" },
  Varna: { uk: "Варна", ru: "Варна" },
  Oldham: { uk: "Олдгем", ru: "Олдхэм" },
  Banyumanik: { uk: "Баньюманік", ru: "Баньюманик" },
  Austin: { uk: "Остін", ru: "Остин" },
  "Stara Zagora": { uk: "Стара Загора", ru: "Стара-Загора" },
  Mamoudzou: { uk: "Мамудзу", ru: "Мамудзу" },
  Gresik: { uk: "Гресік", ru: "Гресик" },
  "Kempton Park": { uk: "Кемптон Парк", ru: "Кемптон Парк" },
  "Cabanatuan City": { uk: "Місто Кабанатуан", ru: "Город Кабанатуан" },
  Bansko: { uk: "Банско", ru: "Банско" },
  Iidabashi: { uk: "Іідабаші", ru: "Иидабаши" },
  Guaçuí: { uk: "Гвасуї", ru: "Гвасуи" },
  "West Rembo": { uk: "Вест Рембо", ru: "Вест Рембо" },
  Suzhou: { uk: "Сучжоу", ru: "Сучжоу" },
  Vilnius: { uk: "Вільнюс", ru: "Вильнюс" },
  "Chiang Mai": { uk: "Чіангмай", ru: "Чиангмай" },
  Machado: { uk: "Мачадо", ru: "Мачадо" },
  Phuket: { uk: "Пхукет", ru: "Пхукет" },
  "Gustavo Adolfo Madero": {
    uk: "Густаво Адольфо Мадеро",
    ru: "Густаво Адольфо Мадеро",
  },
  Rondonópolis: { uk: "Рондонополіс", ru: "Рондонополис" },
  Lahug: { uk: "Лагуг", ru: "Лагуг" },
  "Villa San Agustín": { uk: "Вілла Сан-Агустін", ru: "Вилла Сан-Агустин" },
  "Villa de Cos": { uk: "Вілла-де-Кос", ru: "Вилла-де-Кос" },
  "Santiago de los Caballeros": {
    uk: "Сантьяго-де-лос-Кабальєрос",
    ru: "Сантьяго-де-лос-Кабальерос",
  },
  Probolinggo: { uk: "Проболінгго", ru: "Проболингго" },
  Peshkopi: { uk: "Пешкопі", ru: "Пешкопи" },
  Kampala: { uk: "Кампала", ru: "Кампала" },
  Aguascalientes: { uk: "Агуаскальєнтес", ru: "Агуаскальентес" },
  "Carrizo Springs": { uk: "Каррізо-Спрінгс", ru: "Карризо-Спрингс" },
  Montevideo: { uk: "Монтевідео", ru: "Монтевидео" },
  "Juventino Rosas": { uk: "Хувентіно Роса", ru: "Хувентино Росас" },
  Vinnytsia: { uk: "Вінниця", ru: "Винница" },
  "Puerto Eldorado": { uk: "Пуерто Ельдорадо", ru: "Пуерто Эльдорадо" },
  Tyumen: { uk: "Тюмен", ru: "Тюмень" },
  Karkamış: { uk: "Каркамыш", ru: "Каркамыш" },
  Batumi: { uk: "Батумі", ru: "Батуми" },
  Strand: { uk: "Странд", ru: "Странд" },
  Zhuji: { uk: "Чжужі", ru: "Чжужи" },
  Kilis: { uk: "Кіліс", ru: "Килис" },
  Mojokerto: { uk: "Моджокерто", ru: "Моджокерто" },
  Albion: { uk: "Альбіон", ru: "Альбион" },
  Mīrpur: { uk: "Мірпур", ru: "Мирпур" },
  Prattville: { uk: "Праттвілл", ru: "Праттвилл" },
  Darnah: { uk: "Дерна", ru: "Дерна" },
  "Kamianets-Podilskyi": {
    uk: "Кам'янець-Подільський",
    ru: "Каменец-Подольский",
  },
  "Villa Berthet": { uk: "Вілла Берте", ru: "Вилла Берте" },
  Riobamba: { uk: "Ріобамба", ru: "Риобамба" },
  Pucón: { uk: "Пукон", ru: "Пукон" },
  "Mueang Samut Prakan": {
    uk: "Муанг Самут Пракхан",
    ru: "Муанг Самут Пракхан",
  },
  Nasugbu: { uk: "Насугбу", ru: "Насугбу" },
  Melipilla: { uk: "Меліпілья", ru: "Мелипилья" },
  Molinos: { uk: "Молінос", ru: "Молинос" },
  "Ribeirão Preto": { uk: "Рібейран-Прету", ru: "Рибейран-Прету" },
  Araçatuba: { uk: "Арасатуба", ru: "Арасатуба" },
  Dodoma: { uk: "Додома", ru: "Додома" },
  Magelang: { uk: "Маджела", ru: "Маджеланг" },
  "Curuzú Cuatiá": { uk: "Курусу-Куатія", ru: "Курусу-Куатия" },
  "Lima region": { uk: "Регіон Ліма", ru: "Регион Лима" },
  "Ban Don Kaeo": { uk: "Бан Дон Каео", ru: "Бан Дон Каео" },
  Kock: { uk: "Кок", ru: "Кок" },
  Hohhot: { uk: "Хоххот", ru: "Хохот" },
  Mirandópolis: { uk: "Мірандополіс", ru: "Мирандаполис" },
  Mannheim: { uk: "Мангейм", ru: "Мангейм" },
  Kaifeng: { uk: "Кайфен", ru: "Кайфен" },
  Franca: { uk: "Франка", ru: "Франка" },
  Montelíbano: { uk: "Монте-лібано", ru: "Монте-Либано" },
  Zipaquirá: { uk: "Сіпакіра", ru: "Сипакира" },
  Trang: { uk: "Транг", ru: "Транг" },
  Rengo: { uk: "Ренго", ru: "Ренго" },
  "Santa Bárbara": { uk: "Санта-Барабара", ru: "Санта-Барабара" },
  Macapá: { uk: "Макапа", ru: "Макапа" },
  Osasco: { uk: "Осаcко", ru: "Осаcко" },
  Manchikalapādu: { uk: "Манчікалападу", ru: "Манчикалападу" },
  Kaliningrad: { uk: "Калінінград", ru: "Калининград" },
  Chengdu: { uk: "Ченду", ru: "Ченду" },
  "Entre Rios": { uk: "Ентре-Ріос", ru: "Энтре-Риос" },
  Almaty: { uk: "Алмати", ru: "Алматы" },
  Itapemirim: { uk: "Ітапемірім", ru: "Итапемирим" },
  Acatzingo: { uk: "Акатсінго", ru: "Акатсинго" },
  Barbacena: { uk: "Барбасена", ru: "Барбасена" },
  Konya: { uk: "Конья", ru: "Конья" },
  "Huai Yot": { uk: "Хуай Йот", ru: "Хуай Йот" },
  Buin: { uk: "Буїн", ru: "Буин" },
  Blora: { uk: "Блора", ru: "Блора" },
  Davis: { uk: "Дейвіс", ru: "Дейвис" },
  Tuban: { uk: "Тубан", ru: "Тубан" },
  "Gmina Świebodzin": { uk: "Гміна Свебодзін", ru: "Гмина Свебоджин" },
  Pingdingshan: { uk: "Піндіншань", ru: "Пиндиншань" },
  "Ivano-Frankivsk": { uk: "Івано-Франківськ", ru: "Ивано-Франковск" },
  Reynosa: { uk: "Рейноса", ru: "Рейноса" },
  Lagos: { uk: "Лагос", ru: "Лагос" },
  Pontianak: { uk: "Понтіанак", ru: "Понтианак" },
  "Gmina Widawa": { uk: "Гміна Відава", ru: "Гмина Видава" },
  "Santo Domingo de los Colorados": {
    uk: "Санто-Домінго-де-лос-Колорадас",
    ru: "Санто-Доминго-де-лос-Колорадас",
  },

  "Oklahoma City": { uk: "Оклахома-Сіті", ru: "Оклахома-Сити" },
  Dupnitsa: { uk: "Дупніца", ru: "Дупница" },
  Makhachkala: { uk: "Махачкала", ru: "Махачкала" },
  "Juazeiro do Norte": { uk: "Жуазейру-ду-Норте", ru: "Жуазейру-ду-Норте" },
  Acarigua: { uk: "Акарігуа", ru: "Акаригуа" },
  Ghaziabad: { uk: "Гаджіабад", ru: "Гаджиабад" },
  Centurion: { uk: "Центуріон", ru: "Центурион" },
  Mariópolis: { uk: "Маріополіс", ru: "Мариополис" },
  "Buk-gu": { uk: "Бук-гу", ru: "Бук-гу" },
  "Puerto Plata": { uk: "Пуерто-Плата", ru: "Пуерто-Плата" },
  Kadayanallur: { uk: "Кадаяналлуру", ru: "Кадаяналлуру" },
  Chone: { uk: "Чоне", ru: "Чоне" },
  Corozal: { uk: "Коросаль", ru: "Коросаль" },
  "Sorel-Tracy": { uk: "Сорель-Трасі", ru: "Сорель-Траси" },
  Hattiesburg: { uk: "Геттісбург", ru: "Геттисбург" },
  Biella: { uk: "Біелла", ru: "Биелла" },
  Luanda: { uk: "Луанда", ru: "Луанда" },
  Bayamón: { uk: "Баямон", ru: "Баямон" },
  Reseda: { uk: "Реседа", ru: "Реседа" },
  Gorontalo: { uk: "Горонталу", ru: "Горонталу" },
  Mission: { uk: "Місія", ru: "Миссия" },
  Basavilbaso: { uk: "Басавільбасо", ru: "Басавильбасо" },
  Resistencia: { uk: "Резістенсія", ru: "Резистенсия" },
  "Campos do Jordão": { uk: "Кампус-ду-Жордан", ru: "Кампус-ду-Жордан" },
  Shyshaky: { uk: "Шишаки", ru: "Шишаки" },
  Thessaloniki: { uk: "Салоніки", ru: "Салоники" },
  Navojoa: { uk: "Навохоа", ru: "Навохоа" },
  Marbella: { uk: "Марбелья", ru: "Марбелья" },
  Istmina: { uk: "Істміна", ru: "Истмина" },
  Kondagaon: { uk: "Кондагон", ru: "Кондагаон" },
  Ranchi: { uk: "Ранчі", ru: "Ранчи" },
  Msida: { uk: "Мсіда", ru: "Мсида" },
  Tirana: { uk: "Тирана", ru: "Тирана" },
  Cilandak: { uk: "Чіландак", ru: "Чиландак" },
  Aliança: { uk: "Аліанса", ru: "Альянса" },
  Lucknow: { uk: "Лакнау", ru: "Лакхнау" },
  Medinīpur: { uk: "Медініпур", ru: "Мединіпур" },
  "Várzea Paulista": { uk: "Варзея-Паулісту", ru: "Варзея-Паулиста" },
  Pristina: { uk: "Приштина", ru: "Приштина" },
  "Los Hornillos": { uk: "Лос-Горнільйос", ru: "Лос-Орнильос" },
  Ulujami: { uk: "Улуджамі", ru: "Улуджами" },
  Groningen: { uk: "Гронінген", ru: "Гронинген" },
  "Puerto Asís": { uk: "Пуерто-Асіс", ru: "Пуэрто-Асис" },
  Mosul: { uk: "Мосул", ru: "Мосул" },
  Longueuil: { uk: "Лонгей", ru: "Лонгей" },
  Ahmedabad: { uk: "Ахмедабад", ru: "Ахмедабад" },
  "Santo Domingo Este": { uk: "Санто-Домінго-Есте", ru: "Санто-Доминго-Эсте" },
  "Nakhon Ratchasima": { uk: "Накхон-Ратчасіма", ru: "Накхон-Ратчасима" },
  "La Carlota": { uk: "Ла-Карлота", ru: "Ла-Карлота" },
  Munich: { uk: "Мюнхен", ru: "Мюнхен" },
  Parauapebas: { uk: "Парауапебас", ru: "Парауапебас" },
  Cuiabá: { uk: "Куяба", ru: "Куяба" },
  "Campo Maior": { uk: "Кампо-Майор", ru: "Кампо-Майор" },
  Zhangjiakou: { uk: "Чжанцзякоу", ru: "Чжанцзякоу" },
  Norfolk: { uk: "Норфолк", ru: "Норфолк" },
  Subotica: { uk: "Суботиця", ru: "Суботица" },
  Malakoff: { uk: "Малакоф", ru: "Малакоф" },
  Madiun: { uk: "Мадіун", ru: "Мадиун" },
  Dobrotvir: { uk: "Добротвір", ru: "Добротвир" },
  Lansing: { uk: "Лансинг", ru: "Лансинг" },
  Parral: { uk: "Паррал", ru: "Паррал" },
  Indaiatuba: { uk: "Індаіатуба", ru: "Индаятуба" },
  Pitigala: { uk: "Пітігала", ru: "Питигала" },
  Rungis: { uk: "Рунґіс", ru: "Рунгис" },
  Nakanobu: { uk: "Наканобу", ru: "Наканобу" },
  "Thanh Hóa": { uk: "Тхань Хоа", ru: "Тхань Хоа" },
  "Sungai Buloh": { uk: "Сунгай Булох", ru: "Сунгай Булох" },
  Mostyska: { uk: "Мостиська", ru: "Мостыска" },
  Zagazig: { uk: "Zagazig", ru: "Загазиг" },
  Ibititá: { uk: "Ібітіта", ru: "Ибитита" },
  Ikoma: { uk: "Ікома", ru: "Икома" },
};
